const checkSSnError = (ssn: string, signingMethod: string) => {
  switch (signingMethod) {
    case 'bankid-se':
      return checkSwedishSSN(ssn);
    case 'bankid-no':
      return new RegExp('^[0-9]{11}$').test(ssn);
  }

  return false;
};

const checkSwedishSSN = (ssn: string) => {
  if (!/^\d+$/.test(ssn.trim()) || ssn.length !== 12) {
    return false;
  }

  const newSSN = ssn
    .split("") // convert string to array
    .reverse() // reverse order for Luhn
    .slice(0, 10); // keep only 10 digits (i.e. 1977 becomes 77)

  // verify we got 10 digits, otherwise it is invalid
  if (newSSN.length != 10) {
    return false;
  }

  var sum = newSSN
    // convert to number
    .map(function (n) {
      return Number(n);
    })
    // perform arithmetic and return sum
    .reduce(function (previous, current, index) {
      // multiply every other number with two
      if (index % 2) current *= 2;
      // if larger than 10 get sum of individual digits (also n-9)
      if (current > 9) current -= 9;
      // sum it up
      return previous + current;
    });

  // sum must be divisible by 10
  if (0 !== sum % 10) {
    return false;
  }

  return true;
}

export default checkSSnError;
